import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { LinkLegislacaoService } from '../services/link-legislacao.service';

@Injectable({
  providedIn: 'root',
})
export class LinkLegislacaoResolver implements Resolve<boolean> {
  constructor(private service: LinkLegislacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
